import { Route } from 'react-router-dom';
import { MenuItemType } from '../menu-items';
import { useAuth } from '../providers/authentication';

export function isArrayWithLength(arr: any) {
  return Array.isArray(arr) && arr.length;
}

export function getAllowedRoutes(routes: MenuItemType[]) {
  const auth = useAuth();

  if (!auth) return routes;

  return routes
    .filter(({ id }) => {
      if (auth.permission[id]) {
        return true;
      }
      return false;
      // if (!permission) return true;
      // else if (!isArrayWithLength(permission)) return true;
      // else return permission.find((role) => role === auth.role);
    })
    .map((route) => {
      const { children } = route;
      if (children && children.length > 0) {
        const filterChildRoute = children.filter(({ id }) => {
          if (auth.permission[id]) {
            return true;
          }
          return false;
          // if (!permission) return true;
          // else if (!isArrayWithLength(permission)) return true;
          // else return permission.find((role) => role === auth.role);
        });
        return {
          ...route,
          children: filterChildRoute
        };
      }
      return route;
    });
}

const getChildRoutes = (routes: MenuItemType[]) => {
  return routes.map((route) => (
    <Route key={route.url} path={route.url} element={route.component} />
  ));
};

export default getChildRoutes;
